export default __webpack_public_path__ + "static/media/airr.075fa393.svg";